/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2023-05-29 10:25:33
 * @LastEditTime: 2025-11-21 11:01:08
 */
import React from 'react';
import PriceFlower from '../../components/flower/priceFlower';
import prizeBg from '../../images/prizeBg.png';

const PrizeInfo: React.FC = () => {
  return (
    <div
      className='home-full-row'
      style={{
        backgroundImage: `url(${prizeBg})`,
        backgroundRepeat: 'round',
        marginTop: '0px',
      }}
    >
      <div className='home-row row-padding' style={{ paddingTop: '64px' }}>
        <div className='glod-row'>
        <PriceFlower title={'金奖\n（10项）'} type={'gold'} />
        <PriceFlower title={'银奖\n（20项）'} type={'gold'} />
        <PriceFlower title={'最佳组织奖\n（1项）'} type={'blue'} />
        <PriceFlower title={'金牌导师奖\n（1项）'} type={'blue'} />
        </div>
      </div>
      {/* <div className='home-row row-padding' style={{ marginTop: '60px', paddingBottom: '64px' }}>
        <div className='activity-div-subTitleContainer '>
          <div className='titleContainer-div-separator'></div>
          <Flower title={'专利运营\n优秀榜'} type={'blue'} />
          <Flower title={'专利运营\n价值榜'} type={'blue'} />
          <div className='titleContainer-div-separator'></div>
        </div>
      </div> */}
    </div>
  );
};

export default PrizeInfo;
